import { render, staticRenderFns } from "./SlRelaunch.vue?vue&type=template&id=670e9c9f&scoped=true&lang=html&"
import script from "./SlRelaunch.vue?vue&type=script&lang=js&"
export * from "./SlRelaunch.vue?vue&type=script&lang=js&"
import style0 from "./SlRelaunch.vue?vue&type=style&index=0&id=670e9c9f&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670e9c9f",
  null
  
)

export default component.exports